import { CREATE_ALLOCATOR_NETWORKS, DELETE_ALLOCATOR_NETWORKS, GET_ALLOCATOR_CONTACTS, GET_ALLOCATOR_USERS, IMPORT_ALLOCATOR_CONTACT, SEND_ALLOCATOR_INVITATION_EMAIL, UPDATE_ALLOCATOR_NETWORKS, } from "./constants";

export function getAllocatorUsers(payload) {
  return {
    type: GET_ALLOCATOR_USERS,
    payload
  };
}
export function getAllocatorContacts(payload) {
  return {
    type: GET_ALLOCATOR_CONTACTS,
    payload
  };
}
export function importAllocatorContacts(payload, onSuccess) {
  return {
    type: IMPORT_ALLOCATOR_CONTACT,
    payload,
    onSuccess
  };
}

export function sendInvitationEmail(payload, onSuccess) {
  return {
    type: SEND_ALLOCATOR_INVITATION_EMAIL,
    payload,
    onSuccess
  };
}

export function createAllocatorNetworks(payload) {
  return {
    type: CREATE_ALLOCATOR_NETWORKS,
    payload,
  };
}

export function updateAllocatorNetworks(payload) {
  return {
    type: UPDATE_ALLOCATOR_NETWORKS,
    payload,
  };
}

export function deleteAllocatorNetwork(payload) {
  return {
    type: DELETE_ALLOCATOR_NETWORKS,
    payload
  };
}